
  // Use the exact selector you shared:
  const BECAUSE_SELECTOR = '.image-cont .product-link';

  function refreshBecause(root = document) {
    try {
      if (window.Because && (Because.refresh || Because.init)) {
        (Because.refresh || Because.init).call(Because, root);
        return;
      }
    } catch (e) {}
    const existing = [...document.scripts].find(s => s.src && s.src.includes('because'));
    if (existing) {
      const src = existing.src.split('?')[0] + '?v=' + Date.now();
      const s = document.createElement('script');
      s.async = true;
      s.src = src;
      document.head.appendChild(s);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('#product-grid') || document;
    let tick;
    const mo = new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          // Only react if new nodes contain a Because target to avoid extra work
          if ((m.target || document).querySelector?.(BECAUSE_SELECTOR)) {
            clearTimeout(tick);
            tick = setTimeout(() => refreshBecause(grid), 50);
            break;
          }
        }
      }
    });
    mo.observe(grid, { childList: true, subtree: true }); // watch appended product cards
  });

